/*
 * Site search limited to announcements and tutorials.
 * Reads the Content API key from the search script Ghost injects in {{ghost_head}},
 * loads the post index once and filters it in the browser (works well for Chinese keywords).
 */
(function () {
    const modal = document.querySelector('.gh-search-modal');
    if (!modal) return;

    const input = modal.querySelector('.gh-search-input');
    const results = modal.querySelector('.gh-search-results');
    let index = null;
    let loading = null;

    function apiConfig() {
        const script = document.querySelector('script[data-sodo-search]');
        if (!script || !script.dataset.key) return null;

        return {
            key: script.dataset.key,
            url: script.dataset.sodoSearch.replace(/\/?$/, '/') + 'ghost/api/content/posts/'
        };
    }

    async function loadIndex() {
        const config = apiConfig();
        if (!config) throw new Error('search unavailable');

        const posts = [];
        let page = 1;

        while (page) {
            const params = new URLSearchParams({
                key: config.key,
                filter: 'tag:[announcement,tutorial]',
                fields: 'id,title,url,published_at,custom_excerpt,excerpt',
                include: 'tags',
                order: 'published_at desc',
                limit: '100',
                page: String(page)
            });
            const res = await fetch(config.url + '?' + params.toString());
            if (!res.ok) throw new Error('search request failed');

            const json = await res.json();
            json.posts.forEach(function (post) {
                const slugs = (post.tags || []).map(function (tag) { return tag.slug; });
                posts.push({
                    title: post.title || '',
                    url: post.url,
                    date: post.published_at,
                    excerpt: post.custom_excerpt || post.excerpt || '',
                    type: slugs.indexOf('announcement') > -1 ? '公告' : (slugs.indexOf('tutorial') > -1 ? '教程' : '')
                });
            });
            page = json.meta && json.meta.pagination ? json.meta.pagination.next : null;
        }

        return posts;
    }

    function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    function highlight(text, keyword) {
        const safe = escapeHtml(text);
        if (!keyword) return safe;
        const pattern = escapeHtml(keyword).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return safe.replace(new RegExp(pattern, 'gi'), function (m) { return '<mark>' + m + '</mark>'; });
    }

    function render() {
        const keyword = input.value.trim();

        if (!index) {
            results.innerHTML = '<p class="gh-search-tip">正在加载…</p>';
            return;
        }
        if (!keyword) {
            results.innerHTML = '<p class="gh-search-tip">请输入关键词，支持搜索标题和摘要</p>';
            return;
        }

        const lower = keyword.toLowerCase();
        const matched = index.filter(function (post) {
            return post.title.toLowerCase().indexOf(lower) > -1 || post.excerpt.toLowerCase().indexOf(lower) > -1;
        }).slice(0, 30);

        if (!matched.length) {
            results.innerHTML = '<p class="gh-search-tip">没有找到与“' + escapeHtml(keyword) + '”相关的内容</p>';
            return;
        }

        results.innerHTML = matched.map(function (post) {
            const excerpt = post.excerpt.length > 80 ? post.excerpt.slice(0, 80) + '…' : post.excerpt;
            return '<a class="gh-search-item" href="' + escapeHtml(post.url) + '">' +
                '<span class="gh-search-item-top">' +
                    (post.type ? '<span class="gh-type">' + post.type + '</span>' : '') +
                    '<span class="gh-search-item-title">' + highlight(post.title, keyword) + '</span>' +
                '</span>' +
                (excerpt ? '<span class="gh-search-item-excerpt">' + highlight(excerpt, keyword) + '</span>' : '') +
                '<span class="gh-date">' + formatDate(post.date) + '</span>' +
            '</a>';
        }).join('');
    }

    function open() {
        modal.hidden = false;
        document.documentElement.classList.add('gh-search-open');
        input.focus();

        if (!index) {
            render();
            loading = loading || loadIndex();
            loading.then(function (posts) {
                index = posts;
                render();
            }).catch(function () {
                loading = null;
                results.innerHTML = '<p class="gh-search-tip">搜索暂时不可用，请稍后再试</p>';
            });
        } else {
            render();
        }
    }

    function close() {
        modal.hidden = true;
        document.documentElement.classList.remove('gh-search-open');
    }

    document.querySelectorAll('[data-hc-search]').forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            open();
        });
    });

    modal.querySelectorAll('[data-hc-search-close]').forEach(function (button) {
        button.addEventListener('click', close);
    });

    input.addEventListener('input', render);

    // Capture phase, so Ghost's built-in search (which lists authors and is not limited to our content) does not open
    window.addEventListener('keydown', function (e) {
        if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
            e.preventDefault();
            e.stopImmediatePropagation();
            open();
        } else if (e.key === 'Escape' && !modal.hidden) {
            close();
        }
    }, true);
})();
